'use strict';

bcn.wrapSelects = (function () {

  function wrapIt () {
    $('.js-wrap-selects').each(function () {
      var wrapper = $(this);
      wrapper.find('select').wrap('<div class="styled-select styled-select--short" />');
    });
  }

  return {
    init: function () {
      wrapIt();
    }
  };

})();
